var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24649",
    "data-name": "Path 24649",
    d: "M436.5-1430a67.5,67.5,0,0,0,67.5-67.5,67.5,67.5,0,0,0-67.5-67.5,67.5,67.5,0,0,0-67.5,67.5A67.5,67.5,0,0,0,436.5-1430Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24648",
    "data-name": "Path 24648",
    d: "M0-1258H1920v-342H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24652",
    "data-name": "Path 24652",
    d: "M442.125-1504.672v-.633c0-3.14-2.271-5.695-5.062-5.695s-5.062,2.555-5.062,5.695v4.43h-3.375v2.531h3.242a14.813,14.813,0,0,1-1.928,5.626,1.4,1.4,0,0,0-.056,1.3,1.115,1.115,0,0,0,.992.669H441v-2.531h-8.189a17.792,17.792,0,0,0,1.319-5.063h3.5v-2.531H434.25v-4.43a3.008,3.008,0,0,1,2.813-3.164,3.008,3.008,0,0,1,2.813,3.164v.633Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24655",
    "data-name": "Path 24655",
    d: "M436.384-1477.25c-17.72.069-28.279-25.159-12.215-37.358,3.889-2.953,8.956-3.125,13.6-3.141,3.419-.012,6.963.108,10.035,1.672,5.2,2.646,7.874,8.848,8.766,14.813,1.343,10.539-5.009,20.484-14.849,23.245A19.911,19.911,0,0,1,436.384-1477.25Zm.13-4.52a19.282,19.282,0,0,0,4.642-.744,15.2,15.2,0,0,0,9.224-7.5,21.591,21.591,0,0,0,1.558-12.462,19.208,19.208,0,0,0-4.315-10.742,14.619,14.619,0,0,0-8.9-4.221c-5.847-.765-13.822-.409-18.363,4.223a15.8,15.8,0,0,0-4.067,10.237,22.391,22.391,0,0,0,4.563,15.111c3.593,4.376,9.969,6.336,15.656,6.095Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74257",
    "data-name": "Group 74257",
    transform: "translate(-91.039 -4609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49624",
    "data-name": "Group 49624",
    transform: "translate(-277.961 6174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49623",
    "data-name": "Group 49623",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24647",
    "data-name": "Path 24647",
    d: "M364-1570H509v145H364Z",
    fill: "#45c3b1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49626",
    "data-name": "Group 49626",
    transform: "translate(-277.961 6174)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49625",
    "data-name": "Group 49625",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24650",
    "data-name": "Path 24650",
    d: "M423.625-1516h23.5v30.25h-23.5Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49627",
    "data-name": "Group 49627",
    transform: "translate(150.664 4663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M13.5,6.328V5.7C13.5,2.555,11.229,0,8.437,0S3.375,2.555,3.375,5.7v4.43H0v2.531H3.242a14.818,14.818,0,0,1-1.928,5.626,1.4,1.4,0,0,0-.056,1.3,1.115,1.115,0,0,0,.992.669H12.375V17.719H4.186A17.8,17.8,0,0,0,5.5,12.656H9V10.125H5.625V5.7A3.007,3.007,0,0,1,8.437,2.531,3.007,3.007,0,0,1,11.25,5.7v.633Z",
    fill: "none",
    stroke: "#003160",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49629",
    "data-name": "Group 49629",
    transform: "translate(-277.961 6174)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49628",
    "data-name": "Group 49628",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24653",
    "data-name": "Path 24653",
    d: "M411.25-1522.75h50.5v50.5h-50.5Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49630",
    "data-name": "Group 49630",
    transform: "translate(138.289 4656.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M20.134,40.5C2.413,40.569-8.145,15.341,7.919,3.142,11.808.189,16.876.017,21.519,0c3.419-.012,6.963.108,10.035,1.672,5.2,2.647,7.874,8.849,8.766,14.814,1.343,10.539-5.01,20.483-14.849,23.245A19.928,19.928,0,0,1,20.134,40.5Zm.13-4.52a19.278,19.278,0,0,0,4.641-.745,15.2,15.2,0,0,0,9.224-7.5,21.591,21.591,0,0,0,1.558-12.462A19.2,19.2,0,0,0,31.373,4.535a14.614,14.614,0,0,0-8.9-4.221C16.628-.451,8.654-.095,4.112,4.537A15.8,15.8,0,0,0,.045,14.774,22.39,22.39,0,0,0,4.608,29.885c3.593,4.376,9.969,6.336,15.656,6.1Z",
    fill: "none",
    stroke: "#003160",
    strokeWidth: 1.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.9259fd424750ea7bbdb96808323938f5.svg";
export { ForwardRef as ReactComponent };